<div
  *ngIf="src"
>
  <img
    [src]="src"
  />
</div>
